import React from 'react'
import { PixelTable } from 'pixel-base'
import FinanceCard from '../foundation/FinanceCard'

interface Props {
  title?: string
  variant: 'invoice' | 'vendorBill' | 'journalEntry'
  rows: any[]
}

const presets = {
  invoice: [
    { name: 'Account', selector: (line) => line.account_head_id || '--' },
    { name: 'Description', selector: (line) => line.description || '--' },
    { name: 'Quantity', selector: (line) => line.quantity || '--' },
    { name: 'Unit Price', selector: (line) => line.unit_price || '--' },
    { name: 'Tax', selector: (line) => line.tax_amount || '--' },
    { name: 'Total', selector: (line) => line.total || '--' },
  ],
  vendorBill: [
    { name: 'Account', selector: (line) => line.account_head_id || '--' },
    { name: 'Description', selector: (line) => line.description || '--' },
    { name: 'Quantity', selector: (line) => line.quantity || '--' },
    { name: 'Unit Price', selector: (line) => line.unit_price || '--' },
    { name: 'Tax', selector: (line) => line.tax_amount || '--' },
    { name: 'Total', selector: (line) => line.total || '--' },
  ],
  journalEntry: [
    { name: 'Line', selector: (line) => line.line_no || '--' },
    {
      name: 'Account',
      selector: (line) => line.account?.name || line.account_head_id || '--',
    },
    { name: 'Description', selector: (line) => line.description || '--' },
    {
      name: 'Debit',
      selector: (line) => line.debit_base ?? line.debit ?? '--',
    },
    {
      name: 'Credit',
      selector: (line) => line.credit_base ?? line.credit ?? '--',
    },
  ],
}

const FinanceLineItemsTable: React.FC<Props> = ({
  title = 'Lines',
  variant,
  rows,
}) => (
  <FinanceCard title={title}>
    <PixelTable columns={presets[variant]} data={rows} pagination />
  </FinanceCard>
)

export default FinanceLineItemsTable
